import { useContext } from 'react';
import { AlertContext } from './alertProvider';

function useAlert() {
  const { alert, successAlert, errorAlert } = useContext(AlertContext);
  return { alert, successAlert, errorAlert };
}

export default useAlert;
